if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");

        if (this.form) {
          const idInput = this.form.querySelector("[name=id]");
          if (idInput) idInput.disabled = false;
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        } else {
          const idInput = this.querySelector("[name=id]");
          const submitButton = this.querySelector("button[type=submit]");

          if (idInput) idInput.disabled = false;
          if (submitButton) {
            submitButton.addEventListener(
              "click",
              this.onSubmitHandler.bind(this)
            );
          }
        }

        this.cart = document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');

        if (this.cart && this.submitButton) {
          this.submitButton.setAttribute("aria-haspopup", "dialog");
        }

        this.hideErrors = this.dataset.hideErrors === "true";

        // Additional service on product page
        const productInfo = this.closest(".product__info-container");
        const sectionId = productInfo?.dataset.section;
        this.productAdditionalService = productInfo?.querySelector(
          `product-additional-service[data-section-id="${sectionId}"]`
        );
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (!this.submitButton) return;
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();
        this.error = false;

        this.setLoadingState(true);
        this.prepareFloatingCart();

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = this.form ? new FormData(this.form) : new FormData();

        if (!this.form) {
          const idInput = this.querySelector("[name=id]");
          if (idInput) formData.append("id", idInput.value);
        }

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
        }

        config.body = formData;

        // Changing body of request if additional service is selected
        if (
          this.productAdditionalService &&
          typeof ProductAdditionalService !== "undefined" &&
          this.productAdditionalService instanceof ProductAdditionalService &&
          typeof this.productAdditionalService.getItems === "function" &&
          Array.isArray(ProductAdditionalService.selectedServices) &&
          ProductAdditionalService.selectedServices.length > 0
        ) {
          const items = this.productAdditionalService.getItems(formData);

          if (items?.length > 0) {
            const bodyData = {
              items: items,
            };

            if (this.cart) {
              bodyData.sections = this.cart
                .getSectionsToRender()
                .map((section) => section.id);
              bodyData.sections_url = window.location.pathname;
            }

            delete config.headers["X-Requested-With"];
            config.headers["Content-Type"] = "application/json";
            config.body = JSON.stringify(bodyData);
          }
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleCartError(response, formData);
              return;
            }

            this.handleCartSuccess(response, formData);
          })
          .catch((error) => {
            console.error(error);
            this.recoverFloatingCartIfNeeded();
          })
          .finally(() => {
            this.setLoadingState(false);
          });
      }

      handleCartSuccess(response, formData) {
        this.error = false;

        this.renderCartSectionsSilently(response);

        this.clearAdditionalServicesIfNeeded();

        if (typeof publish === "function" && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "product-form",
            productVariantId: formData.get("id"),
          });
        }

        // CT: PUB_SUB_EVENTS.cartUpdate 会触发浮动购物车刷新，移除重复调用
        // 保留 playFlyToCartAnimation 因为它提供视觉反馈

        this.playFlyToCartAnimation();

        window.dispatchEvent(
          new CustomEvent("ct:product-added", {
            detail: {
              source: "product-form",
              productVariantId: formData.get("id"),
              response: response,
            },
          })
        );
      }

      handleCartError(response, formData) {
        this.error = true;

        if (typeof publish === "function" && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: "product-form",
            productVariantId: formData.get("id"),
            errors: response.description,
            message: response.message,
          });
        }

        this.handleErrorMessage(response.description);

        const soldOutMessage =
          this.submitButton.querySelector(".sold-out-message");

        if (soldOutMessage) {
          this.submitButton.setAttribute("aria-disabled", "true");

          const firstSpan = this.submitButton.querySelector("span");
          if (firstSpan) firstSpan.classList.add("hidden");

          soldOutMessage.classList.remove("hidden");
        }

        this.recoverFloatingCartIfNeeded();
        this.setLoadingState(false);
      }

      setLoadingState(isLoading) {
        if (!this.submitButton) return;

        const spinner = this.querySelector(".loading-overlay__spinner");

        if (isLoading) {
          this.submitButton.setAttribute("aria-disabled", "true");
          this.submitButton.classList.add("loading");
          if (spinner) spinner.classList.remove("hidden");
        } else {
          this.submitButton.classList.remove("loading");

          if (!this.error) {
            this.submitButton.removeAttribute("aria-disabled");
          }

          if (spinner) spinner.classList.add("hidden");
        }
      }

      prepareFloatingCart() {
        if (
          window.ctFloatingCart &&
          typeof window.ctFloatingCart.prepareForIncomingItem === "function"
        ) {
          window.ctFloatingCart.prepareForIncomingItem();
        }
      }

      recoverFloatingCartIfNeeded() {
        if (
          window.ctFloatingCart &&
          typeof window.ctFloatingCart.refresh === "function"
        ) {
          window.ctFloatingCart.refresh({ pulse: false });
        }
      }

      clearAdditionalServicesIfNeeded() {
        if (
          this.productAdditionalService &&
          typeof ProductAdditionalService !== "undefined" &&
          this.productAdditionalService instanceof ProductAdditionalService &&
          typeof this.productAdditionalService.clearItems === "function" &&
          Array.isArray(ProductAdditionalService.selectedServices) &&
          ProductAdditionalService.selectedServices.length > 0
        ) {
          this.productAdditionalService.clearItems();
        }
      }

      renderCartSectionsSilently(parsedState) {
        if (!this.cart || !parsedState || !parsedState.sections) return;

        this.cart.classList.remove("is-empty");

        this.cart.getSectionsToRender().forEach((section) => {
          const sectionHtml = parsedState.sections[section.id];
          if (!sectionHtml) return;

          const sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);

          if (!sectionElement) return;

          const newHtml = this.getSectionInnerHTML(sectionHtml, section.selector);

          if (newHtml !== null) {
            sectionElement.innerHTML = newHtml;
          }
        });

        this.rebindCartDrawerOverlay();
        this.initCartPopularProductsSlider();
      }

      rebindCartDrawerOverlay() {
        if (!this.cart) return;

        const overlay = this.cart.querySelector("#CartDrawer-Overlay");
        if (!overlay) return;

        overlay.addEventListener("click", this.cart.close.bind(this.cart, false));
      }

      initCartPopularProductsSlider() {
        const slider = document.querySelector("cart-popular-products-slider");

        if (slider && typeof slider.init === "function") {
          slider.init();
        }
      }

      getSectionInnerHTML(html, selector = ".shopify-section") {
        const parsedHTML = new DOMParser().parseFromString(html, "text/html");
        const target = parsedHTML.querySelector(selector);

        return target ? target.innerHTML : null;
      }

      playFlyToCartAnimation() {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
          this.pulseFloatingCart();
          return;
        }

        const targetRect = this.getFloatingCartTargetRect();
        if (!targetRect) {
          this.pulseFloatingCart();
          return;
        }

        const sourceImage = this.findProductImage();
        if (!sourceImage) {
          this.pulseFloatingCart();
          return;
        }

        const sourceRect = sourceImage.getBoundingClientRect();

        if (
          sourceRect.width < 20 ||
          sourceRect.height < 20 ||
          sourceRect.bottom < 0 ||
          sourceRect.right < 0 ||
          sourceRect.top > window.innerHeight ||
          sourceRect.left > window.innerWidth
        ) {
          this.pulseFloatingCart();
          return;
        }

        const clone = sourceImage.cloneNode(true);
        const startSize = Math.min(sourceRect.width, sourceRect.height, 130);
        const startLeft = sourceRect.left + sourceRect.width / 2 - startSize / 2;
        const startTop = sourceRect.top + sourceRect.height / 2 - startSize / 2;

        const endSize = 26;
        const endLeft = targetRect.left + targetRect.width / 2 - endSize / 2;
        const endTop = targetRect.top + targetRect.height / 2 - endSize / 2;

        clone.setAttribute("aria-hidden", "true");
        clone.classList.add("ct-fly-to-cart-image");
        clone.style.position = "fixed";
        clone.style.left = `${startLeft}px`;
        clone.style.top = `${startTop}px`;
        clone.style.width = `${startSize}px`;
        clone.style.height = `${startSize}px`;
        clone.style.objectFit = "cover";
        clone.style.borderRadius = "16px";
        clone.style.pointerEvents = "none";
        clone.style.zIndex = "2147483647";
        clone.style.boxShadow = "0 14px 36px rgba(20, 24, 18, 0.22)";
        clone.style.background = "#ffffff";

        document.body.appendChild(clone);

        const deltaX = endLeft - startLeft;
        const deltaY = endTop - startTop;
        const distance = Math.hypot(deltaX, deltaY);
        const arcHeight = Math.min(180, Math.max(72, distance * 0.22));
        const controlX = startLeft + deltaX * 0.5;
        const controlY = startTop + deltaY * 0.28 - arcHeight;

        const sampleCurvePoint = (t) => {
          const inverse = 1 - t;
          return {
            x:
              inverse * inverse * startLeft +
              2 * inverse * t * controlX +
              t * t * endLeft,
            y:
              inverse * inverse * startTop +
              2 * inverse * t * controlY +
              t * t * endTop,
          };
        };

        const createFrame = (t, scale, opacity, rotate = 0) => {
          const point = sampleCurvePoint(t);

          return {
            transform: `translate3d(${point.x - startLeft}px, ${point.y - startTop}px, 0) scale(${scale}) rotate(${rotate}deg)`,
            opacity,
            offset: t,
          };
        };

        const animation = clone.animate(
          [
            createFrame(0, 1, 1, 0),
            createFrame(0.24, 0.92, 0.98, -2),
            createFrame(0.56, 0.68, 0.9, 2),
            createFrame(0.82, 0.4, 0.42, 1),
            createFrame(1, 0.22, 0, 0),
          ],
          {
            duration: 680,
            easing: "cubic-bezier(0.16, 0.84, 0.22, 1)",
            fill: "forwards",
          }
        );

        animation.onfinish = () => {
          clone.remove();
          this.pulseFloatingCart();
        };

        animation.oncancel = () => {
          clone.remove();
        };
      }

      getFloatingCartTargetRect() {
        if (
          window.ctFloatingCart &&
          typeof window.ctFloatingCart.getTargetRect === "function"
        ) {
          const rect = window.ctFloatingCart.getTargetRect();

          if (rect && rect.width > 0 && rect.height > 0) {
            return rect;
          }
        }

        const floatingCart = document.getElementById("ct-floating-cart");
        if (floatingCart) {
          const rect = floatingCart.getBoundingClientRect();

          if (rect && rect.width > 0 && rect.height > 0) {
            return rect;
          }
        }

        const headerCart = document.getElementById("cart-icon-bubble");
        if (headerCart) {
          const rect = headerCart.getBoundingClientRect();

          if (rect && rect.width > 0 && rect.height > 0) {
            return rect;
          }
        }

        return null;
      }

      pulseFloatingCart() {
        if (
          window.ctFloatingCart &&
          typeof window.ctFloatingCart.pulse === "function"
        ) {
          window.ctFloatingCart.pulse();
        }
      }

      findProductImage() {
        const scopes = [
          this.closest(".card-wrapper"),
          this.closest(".collection-product-card"),
          this.closest("quick-add-modal"),
          this.closest(".quick-add-modal"),
          this.closest(".product"),
          this.closest(".product__outer"),
          document,
        ].filter(Boolean);

        const selectors = [
          ".card__inner img.media--first",
          ".card__inner .media img",
          ".media.media--hover-effect img",
          ".product__media img",
          ".product__media-list img",
          ".product__main img",
          ".quick-add-modal img",
          "img",
        ];

        for (const scope of scopes) {
          for (const selector of selectors) {
            const images = Array.from(scope.querySelectorAll(selector));

            const visibleImage = images.find((image) => {
              const rect = image.getBoundingClientRect();

              return (
                image.currentSrc ||
                image.src
              ) && rect.width > 20 && rect.height > 20;
            });

            if (visibleImage) return visibleImage;
          }
        }

        return null;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}